export default "__VITE_ASSET__DEUuU25v__"